import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable, tap } from "rxjs";
import { environment } from "../../../environments/environment";
import { SessionService } from './session.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private _http : HttpClient, private session : SessionService) { }

  login(credentials : any) : Observable<any>{
    return this._http.post(`${environment.apiUrl}/api/auth/login`, credentials).pipe(
        tap((res : any) => this.session.login(res.token))
      );
  }

  logout(){
    this.session.logout();
  }

  register(registerForm : any) : Observable<any>{
    return this._http.post(`${environment.apiUrl}/api/auth/register`, registerForm);
  }

  forgotPassword(email: string){
    return this._http.post(`${environment.apiUrl}/api/auth/forgot-password`, {email})
  }

  resetPassword(form:any){
    return this._http.post(`${environment.apiUrl}/api/auth/reset-password`, form)
  }

}
